'use client';

import { c as _c } from "react/compiler-runtime";
import { type TextProps } from '@builder.io/react/dist/types/src/blocks/Text';
import { useContext } from 'react';
import { CountdownContext } from '@src/components/CountdownWrapper/CountdownWrapper';
import { useClickAction } from '@src/hooks/useClickAction/useClickAction';
import { type UseClickActionArgs } from '@src/hooks/useClickAction/useClickActionArgs';
import { cn } from '@src/utils/tailwind';
import NumberCountdown from './NumberCountdown';
export const textStyleMap = {
  'Display Heading 1': 'text-heading-display-1',
  'Display Heading 2': 'text-heading-display-2',
  'Display Heading 3': 'text-heading-display-3',
  'Heading 1': 'text-heading-1',
  'Heading 2': 'text-heading-2',
  'Heading 3': 'text-heading-3',
  'Heading 4': 'text-heading-4',
  'Heading 5': 'text-heading-5',
  'Body XL': 'text-body-xl',
  'Body XL - Medium weight': 'text-body-xl font-medium',
  'Body LG': 'text-body-lg',
  'Body LG - Medium weight': 'text-body-lg font-medium',
  'Body MD': 'text-body-md',
  // TODO: remove this once all uses are gone
  'Body MD - Medium weight': 'text-body-md font-medium',
  // TODO: remove this once all uses are gone
  'Body Base': 'text-body-base',
  'Body Base - Medium weight': 'text-body-base font-medium',
  'Body SM': 'text-body-sm',
  'Body SM - Medium weight': 'text-body-sm font-medium',
  'Body XS': 'text-body-xs',
  'Body XS - Medium weight': 'text-body-xs font-medium'
};
type CustomTextProps = TextProps & UseClickActionArgs & {
  style: string;
  timePeriod?: 'seconds' | 'minutes' | 'hours' | 'days';
  getValueFromCountdown?: boolean;
  animated?: boolean;
  builderBlock?: any;
  animatedBackground?: string;
};
export const Text = props => {
  const $ = _c(17);
  const {
    text,
    style: t0,
    timePeriod,
    getValueFromCountdown,
    animated,
    builderBlock,
    animatedBackground
  } = props;
  const style = t0 === undefined ? "Body MD" : t0;
  const countdown = useContext(CountdownContext);
  const {
    ClickWrapper,
    handlers,
    isWrapping
  } = useClickAction(props);
  const textStyle = textStyleMap[style as keyof typeof textStyleMap];
  const actionName = props.actionName;
  const hasAction = !isWrapping && actionName && actionName !== "none";
  let t1;
  if ($[0] !== hasAction) {
    t1 = hasAction ? {
      role: "button",
      tabIndex: 0
    } : {};
    $[0] = hasAction;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const divButtonProps = t1;
  const currentCountdown = countdown?.currentCountdown;
  const selectedTimePeriod = timePeriod && !isNaN(currentCountdown?.[timePeriod]) ? currentCountdown?.[timePeriod] : null;
  let t2;
  if ($[2] !== animated || $[3] !== animatedBackground || $[4] !== builderBlock || $[5] !== divButtonProps || $[6] !== getValueFromCountdown || $[7] !== handlers || $[8] !== hasAction || $[9] !== isWrapping || $[10] !== selectedTimePeriod || $[11] !== text || $[12] !== textStyle) {
    t2 = getValueFromCountdown && !isNaN(selectedTimePeriod) && selectedTimePeriod !== null ? <NumberCountdown animated={!!animated} selectedTimePeriod={selectedTimePeriod} textStyle={textStyle} builderBlock={builderBlock} animatedBackground={animatedBackground as string} {...divButtonProps} {...!isWrapping && handlers} /> : <span {...divButtonProps} {...!isWrapping && handlers} suppressHydrationWarning={true} className={cn("builder-text prose", textStyle, {
      "cursor-pointer": hasAction
    })} dangerouslySetInnerHTML={{
      __html: text
    }} />;
    $[2] = animated;
    $[3] = animatedBackground;
    $[4] = builderBlock;
    $[5] = divButtonProps;
    $[6] = getValueFromCountdown;
    $[7] = handlers;
    $[8] = hasAction;
    $[9] = isWrapping;
    $[10] = selectedTimePeriod;
    $[11] = text;
    $[12] = textStyle;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== ClickWrapper || $[15] !== t2) {
    t3 = <ClickWrapper>{t2}</ClickWrapper>;
    $[14] = ClickWrapper;
    $[15] = t2;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
};